import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { apiService, thunk } from './middleware';
import * as reducers from './modules';
import createFormReducer from 'components/connectedForm/utils/reducer';

export default function configureStore() {
  const rootReducer = combineReducers({
    app: reducers.app,
    data: reducers.service,
    newform: createFormReducer(),
    views: reducers.view,
    haggle: reducers.haggle,
    menu: reducers.menu,
    tab: reducers.tab,
  });

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          maxAge: 25,
        })
      : compose;

  const enhancer = composeEnhancers(applyMiddleware(thunk, apiService));

  return createStore(rootReducer, enhancer);
}
